import React from "react";
import { ArrowUpRight } from "lucide-react";
import "./TpcTradeFloorFacilities.css";

import tradeFloorImage from "../../images/tradeFloor5.webp";
import chartBg from "../../images/Chart 3.webp";

const facilityCards = [
  {
    id: "setups",
    eyebrow: "Setups",
    value: "Multi-screen",
    body: "Proper desks for proper chart work.",
    trend: "gold",
  },
  {
    id: "environment",
    eyebrow: "Environment",
    value: "Focused",
    body: "Clean space. Quiet intensity.",
    trend: "green",
  },
  {
    id: "reps",
    eyebrow: "Routine",
    value: "Daily reps",
    body: "Plan. Execute. Review.",
    trend: "red",
  },
];

const marketCandles = [
  "green",
  "red",
  "green",
  "green",
  "gold",
  "red",
  "green",
  "green",
  "red",
  "green",
  "gold",
];

function TpcTradeFloorFacilities({
  ctaHref = "https://andus.co.za/trade-register",
  ctaLabel = "Apply Now",
}) {
  return (
    <section
      id="tpc-trade-floors"
      className="trpc-floorFacility"
      aria-labelledby="trpc-floorFacility-title"
    >
      <div className="trpc-floorFacility__shell">
        <article className="trpc-floorFacility__stage">
          <div className="trpc-floorFacility__media">
            <img
              className="trpc-floorFacility__image"
              src={tradeFloorImage}
              alt="TPC trade floor with multi-screen trading desks and live market charts"
              loading="lazy"
              decoding="async"
            />

            <img
              className="trpc-floorFacility__chart"
              src={chartBg}
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
            />

            <div className="trpc-floorFacility__shade" aria-hidden="true" />
            <div className="trpc-floorFacility__grid" aria-hidden="true" />
            <span className="trpc-floorFacility__priceLine" aria-hidden="true" />

            <div className="trpc-floorFacility__candles" aria-hidden="true">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-floorFacility__candle"
                  data-trend={trend}
                />
              ))}
            </div>

            <div className="trpc-floorFacility__route" aria-hidden="true">
              <span>Train</span>
              <strong>→</strong>
              <span>Execute</span>
            </div>

            <div className="trpc-floorFacility__caption" aria-hidden="true">
              TPC live floor
            </div>
          </div>

          <div className="trpc-floorFacility__copy">
            <span className="trpc-floorFacility__kicker">
              World-class facilities
            </span>

            <h2
              id="trpc-floorFacility-title"
              className="trpc-floorFacility__title"
            >
              <span>Train where</span>
              <span>traders execute.</span>
            </h2>

            <p className="trpc-floorFacility__lead">
              Purpose-built desks. Live charts. Space to focus. Methodology
              becomes reps.
            </p>

            <a className="trpc-floorFacility__btn" href={ctaHref} target="_blank" rel="noopener noreferrer">
              <span>{ctaLabel}</span>
              <ArrowUpRight size={17} strokeWidth={2.4} aria-hidden="true" />
            </a>
          </div>

          <div
            className="trpc-floorFacility__cardDeck"
            aria-label="Trade floor facility highlights"
          >
            {facilityCards.map((card) => (
              <article
                key={card.id}
                className="trpc-floorFacility__card"
                data-trend={card.trend}
              >
                <span
                  className="trpc-floorFacility__cardRule"
                  aria-hidden="true"
                />
                <p className="trpc-floorFacility__cardEyebrow">
                  {card.eyebrow}
                </p>
                <strong className="trpc-floorFacility__cardValue">
                  {card.value}
                </strong>
                <p className="trpc-floorFacility__cardBody">{card.body}</p>
              </article>
            ))}
          </div>
        </article>
      </div>
    </section>
  );
}

export default TpcTradeFloorFacilities;